import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/VFInformation';
import applicationService from '../../../../../services/Internal/Application/VF/vfApplication.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import { Form, Schema } from 'rsuite';
import Swal from 'sweetalert2';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import WavierCertificate from '../../../../Shared/Card/WaiverCertificate';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Issues from '../../../../Shared/Card/Issues';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import SOSLookup from '../../../../Shared/Card/SOSLookup';

function WaiverCertificatePage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Surveying Firm Application",
            isIndividual: false,
            entityId: 0,
            applicationDate: "",
            currentSection: "Waiver/Certificate"
        }
    );
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 13;
    const { StringType, BooleanType } = Schema.Types;
    const model = Schema.Model({
        hasWordOfferingProfessionalServices: BooleanType().isRequired('This field is required.'),
        electronicSignature: StringType().isRequired('This field is required.')
    });
    useEffect(() => {
        setHasLoaded(false);
        applicationService.vfGetSection(store.currentApplicationId, sectionId).then((response) => {
            setSectionData(response.data);
            setIsComplete(response.data.staffReviewComplete);
            applicationService.getFirmApplication(store.currentApplicationId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            })
        })


    }, [])
    const store = useSelector(x => x);

    const push = useNavigate();
    const showAdditionalFields = sectionData.hasWordOfferingProfessionalServices;

    const handleSubmit = (val, event) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else if (val) {
            applicationService.vfPostSection(store.currentApplicationId, sectionId, sectionData.electronicSignature).then((response) => {
                if (response.data) {
                    applicationService.vfPostSectionHasWordOffering(store.currentApplicationId, sectionId, sectionData.hasWordOfferingProfessionalServices).then((data) => {
                        if (data.data) {
                            applicationService.vfMarkSectionComplete(store.currentApplicationId, sectionId, isComplete).then((markSectionResponse) => {
                                if (markSectionResponse.data) {
                                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                                }
                                else
                                    Swal.fire("Failed to mark section as complete");
                            });
                        }
                        else
                            Swal.fire("Failed to save section has word offering.")
                    })
                }
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <Form model={model} onSubmit={handleSubmit} onChange={setSectionData} fluid formValue={sectionData}>
                    <FormEntityInformation {...entityInfo} />
                    <Row className="mb-3">
                        <Col> <Information content={GetAppInformationContent("waiver")} /></Col>
                    </Row>
                    {hasLoaded ?
                        <>
                            <Row className="mb-3">
                                <Col>
                                    <SOSLookup entityName={entityInfo.entityName} />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <WavierCertificate
                                        isReadOnly={!isUserEditable}
                                        showAdditionalFields={showAdditionalFields}
                                        isApp={true}
                                        isInternal={true}
                                        sectionId={sectionId}
                                        sectionDataId={sectionData.id}
                                        entityId={entityInfo.entityId}
                                        parentTypeId={1}
                                        credentialTypeId={2}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={1} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete}
                                showSectionComplete={true}
                                backToSectionLink="/internal/vfApp/sections" />
                        </> : <LoadingSpinner />
                    }
                </Form>
            </Container>
        </div>
    );
}
export default WaiverCertificatePage